<template>
	<div class="home">
    <!-- 固定栏 -->
    <div class="fixed-content">
      <!-- 搜索框 -->
      <div class="serachInput bg-fff">
        <div class="dropdownBox">
          <div id="trigger1" class="dropdown font-size-14px">{{selectData.name}}</div>
          <div id="trigger" class="dropdown margin-left-20 font-size-14px">{{nationsData.name}}</div>
        </div>
        <div class="serach bg-f5f5f5">
          <input class="bg-f5f5f5 font-size-28" type="text" placeholder="请输入姓名／学号" v-model="searchValue">
          <img class="deleteBtn" @click="deletInput()" src="static/images/searchDelete.png" />
          <div class="serachBtn color-fff margin-left-20 font-size-14px" @click="searchClick()">搜索</div>
        </div>
      </div>

      <!-- 文字说明 -->
      <div class="padding-20 bg-appStyle color-fff">
        <p class="font-size-14px">总数：{{totalData.totalPerson}}人</p>
        <p class="font-size-14px margin-top-10">在寝：{{totalData.inDormNum}}人  不在寝：{{totalData.unDormNum}}人  无活动：{{totalData.noActiveNum}}人</p>
        <p class="font-size-14px margin-top-10">请假：{{totalData.leaveNum}}人</p>
      </div>

      <div class="cut-line"></div>

      <!-- tabBtn -->
      <div class="tabBtn">
        <mt-navbar class="navBar" v-model="selected">
          <mt-tab-item class="tabBtnNav" id="1">在寝{{totalData.inDormNum}}人<p>({{totalData.leaveNumInInDorm}}人)</p></mt-tab-item>
          <mt-tab-item class="tabBtnNav" id="2">不在寝{{totalData.unDormNum}}人<p>({{totalData.leaveNumInUnDorm}}人)</p></mt-tab-item>
          <mt-tab-item class="tabBtnNav" id="3">无活动{{totalData.noActiveNum}}人<p>({{totalData.leaveNumInNoActive}}人)</p></mt-tab-item>
          <mt-tab-item class="tabBtnNav" id="4">请假{{totalData.leaveNum}}人</mt-tab-item>
        </mt-navbar>
      </div>

      <!-- tab-container -->
      <div class="border-bottom margin-top-20 bg-appStyle color-fff">
        <mt-tab-container v-model="selected">
          <mt-tab-container-item id="1">
            <div class="grid">
              <div class="gridWarp nopadding noborder">
                <div class="gridCell flex-1">
                  学号
                </div>
                <div class="gridCell flex-1">
                  姓名
                </div>
                <div class="gridCell flex-basis-80">
                  楼房号
                </div>
                <div class="gridCell flex-1">
                  日期
                </div>
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="2">
            <div class="grid">
              <div class="gridWarp nopadding noborder">
                <div class="gridCell flex-1">
                  学号
                </div>
                <div class="gridCell flex-1">
                  姓名
                </div>
                <div class="gridCell flex-basis-80">
                  楼房号
                </div>
                <div class="gridCell flex-1">
                  日期
                </div>
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="3">
            <div class="grid">
              <div class="gridWarp nopadding noborder">
                <div class="gridCell flex-1">
                  学号
                </div>
                <div class="gridCell flex-1">
                  姓名
                </div>
                <div class="gridCell flex-basis-80">
                  楼房号
                </div>
                <div class="gridCell flex-1">
                  原因
                </div>
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="4">
            <div class="grid">
              <div class="gridWarp nopadding noborder">
                <div class="gridCell flex-1">
                  姓名
                </div>
                <div class="gridCell flex-basis-80">
                  楼房号
                </div>
                <div class="gridCell flex-1">
                  原因
                </div>
              </div>
            </div>
          </mt-tab-container-item>
        </mt-tab-container>
      </div>

    </div>

    <!-- 内容栏 -->
    <div class="scroll-content">
      <div>
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <mt-tab-container v-model="selected">
            <mt-tab-container-item id="1">
              <div class="tabContent">
                <!--暂时无相关数据-->
                <div class="noData" v-if="list.length == 0">
                    <div style="padding-bottom: 7rem;">
                        <img src="static/images/default-null.png"  alt="">
                        <p>暂时无相关数据</p>
                    </div>
                </div>
                <div class="grid" v-if="list.length > 0">
                  <div class="gridWarp"  v-for="(item, index) in list" :key="index">
                    <div class="gridCell flex-1">
                      {{item.studentNo}}
                    </div>
                    <div class="gridCell flex-1" v-html="item.userName"></div>
                    <div class="gridCell flex-basis-80">
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.dormAreaSimpleName}}</p>
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.roomNum}}</p>
                      <p v-if="!item.dormAreaSimpleName || !item.roomNum">{{item.dormRoomName}}</p>
                    </div>
                    <div class="gridCell flex-1">
                      {{item.lastFaceActionTime}}
                    </div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <mt-tab-container-item id="2">
              <div class="tabContent">
                <!--暂时无相关数据-->
                <div class="noData" v-if="list.length == 0">
                    <div style="padding-bottom: 7rem;">
                        <img src="static/images/default-null.png"  alt="">
                        <p>暂时无相关数据</p>
                    </div>
                </div>
                <div class="grid" v-if="list.length > 0">
                  <div class="gridWarp" v-for="(item, index) in list" :key="index">
                    <div class="gridCell flex-1">
                      {{item.studentNo}}
                    </div>
                    <div class="gridCell flex-1" v-html="item.userName"></div>
                    <div class="gridCell flex-basis-80">
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.dormAreaSimpleName}}</p>
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.roomNum}}</p>
                      <p v-if="!item.dormAreaSimpleName || !item.roomNum">{{item.dormRoomName}}</p>
                    </div>
                    <div class="gridCell flex-1">
                      {{item.lastFaceActionTime}}
                    </div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <mt-tab-container-item id="3">
              <div class="tabContent">
                <!--暂时无相关数据-->
                <div class="noData" v-if="list.length == 0">
                    <div style="padding-bottom: 7rem;">
                        <img src="static/images/default-null.png"  alt="">
                        <p>暂时无相关数据</p>
                    </div>
                </div>
                <div class="grid" v-if="list.length > 0">
                  <div class="gridWarp" v-for="(item, index) in list" :key="index">
                    <div class="gridCell flex-1">
                      {{item.studentNo}}
                    </div>
                    <div class="gridCell flex-1" v-html="item.userName"></div>
                    <div class="gridCell flex-basis-80">
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.dormAreaSimpleName}}</p>
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.roomNum}}</p>
                      <p v-if="!item.dormAreaSimpleName || !item.roomNum">{{item.dormRoomName}}</p>
                    </div>
                    <div class="gridCell flex-1">
                      {{item.reason}}
                    </div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <mt-tab-container-item id="4">
              <div class="tabContent">
                <!--暂时无相关数据-->
                <div class="noData" v-if="list.length == 0">
                    <div style="padding-bottom: 7rem;">
                        <img src="static/images/default-null.png"  alt="">
                        <p>暂时无相关数据</p>
                    </div>
                </div>
                <div class="grid" v-if="list.length > 0">
                  <div class="gridWarp" v-for="(item, index) in list" :key="index">
                    <div class="gridCell flex-1" v-html="item.userName"></div>
                    <div class="gridCell flex-basis-80">
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.dormAreaSimpleName}}</p>
                      <p v-if="item.dormAreaSimpleName && item.roomNum">{{item.roomNum}}</p>
                      <p v-if="!item.dormAreaSimpleName || !item.roomNum">{{item.dormRoomName}}</p>
                    </div>
                    <div class="gridCell flex-1">
                      {{item.reason}}
                    </div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
          </mt-tab-container>
        </mt-loadmore>
      </div>
    </div>
    

	</div>
</template>

<script>

import { mapGetters } from "vuex";
import { Navbar, TabItem } from 'mint-ui';
import { Loadmore } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';
import MobileSelect from 'mobile-select';

import service from "@/fetch/service";
export default {
  components: {
    Navbar,
    TabItem
  },
  data() {
    return {
      searchValue: '', //搜索框值
      oldSearchValue: '', //搜索框值old
      selected: '1', //默认当前的tab 页面 类型[1在宿 2不宿 3无活动 4请假]
      pageNo: 1, //分页
      pageSize: 20, //每次请求的个数
      allLoaded: true,//是否加载完毕
      haveMore: true, //是否有更多数据
      totalData: {
        totalPerson: 0, //总数
        inDormNum: 0, //在寝人数
        leaveNum: 0, //请假人数
        noActiveNum: 0, //无活动
        unDormNum: 0 //不在寝室人数
      }, //在寝人数 不在寝室人数 无活动人数 请假人数
      selectDataArr: [
        {
          id: '',
          value: '选择年级'
        }
      ],
      selectData: { //当前下拉框的值
        name: '选择年级',
        value: ''
      },
      nationsDataArr: [
        {
          id: '',
          value: '选择民族'
        }
      ],
      nationsData: { //当前下拉框的值
        name: '选择民族',
        value: ''
      },
      list: [], //数据
    };
  },
  created() {
    //请求 获取年级
    this.getGradeList();
    //请求 获取名族
    this.getNationsList();
    this.loaddata();
  },
  computed: {
    ...mapGetters([])
  },
  mounted() {},
  watch: {
    'selected': function() {
      this.loadTop();
    }
  },
  methods: {
    //一行只能显示4个字 多余的换行
    lineFourText: function (str) {
      if (!str) return ''
      let newStr = ''
      for (let index = 0; index < str.length; index++) {
        newStr += str[index]
        if ((index + 1) % 4 == 0) {
          newStr += '<br />'
        }
      }
      
      return newStr
    },
    //清除input里面的值
    deletInput: function () {
      if (!this.searchValue) {
        return
      }
      this.searchValue = '';
      this.loadTop();
    },
    //搜索按钮
    searchClick: function () {
      if (this.oldSearchValue != this.searchValue) {
        this.loadTop();
      }
    },
    //获取年级
    getGradeList: function () {
      var that = this
      service
      .gradeList({})
      .then(res => {
        console.log(res);
        if (res.success) {
          res.result.forEach(element => {
            this.selectDataArr.push({
              id: element,
              value: element + '级'
            })
          });
          var mobileSelect4 = new MobileSelect({
              trigger: "#trigger1",
              title: "请选择年级",
              wheels: [
                {data: this.selectDataArr}
              ],
              callback:function(indexArr, data){
                  console.log(data);
                  that.selectData = {
                    name: data[0].value,
                    value: data[0].id
                  }
                  that.loadTop();
              }
          });
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    //获取民族
    getNationsList: function () {
      var that = this
      service
      .nationList({})
      .then(res => {
        if (res.success) {
          res.result.forEach(element => {
            this.nationsDataArr.push({
              id: element.code,
              value: element.name
            })
          });
          var mobileSelect = new MobileSelect({
              trigger: "#trigger",
              title: "请选择民族",
              wheels: [
                {data: this.nationsDataArr}
              ],
              callback:function(indexArr, data){
                  console.log(data);
                  that.nationsData = {
                    name: data[0].value,
                    value: data[0].id
                  }
                  that.loadTop();
              }
          });
          
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    loadBottom: function(){//上拉加载更多
      console.log("上拉加载更多");
      this.more();                 
      this.$refs.loadmore.onBottomLoaded();
    },
    loadTop: function(){//下拉刷新
      this.pageNo =1;
      this.loaddata();               
      this.$refs.loadmore.onTopLoaded();
    },
    more() {
      // 分页查询
      this.pageNo++;
      this.loaddata();
    },
    loaddata(){ //加载数据从vuex中拿数据
      this.$store.dispatch("setLoadingState", true);
      console.log(this.selectData)
      service
        .nationSearch({
          "grade": this.selectData.value,
          "nationCode": this.nationsData.value,
          "nameOrNo": this.searchValue,
          "type":  this.selected,
          "page": this.pageNo,
          "limit": this.pageSize
        })
        .then(res => {
          console.log(res);
          this.$store.dispatch("setLoadingState", false);
          let result = res.result;
          console.log(this.allLoaded);
          if (res.success) {
            this.oldSearchValue = this.searchValue;
            this.totalData = result.totalData;
            this.totalData.totalPerson = result.totalData.inDormNum + result.totalData.unDormNum + result.totalData.noActiveNum + result.totalData.leaveNum;
            let listArr = result.pageInfo.rows;
            listArr.forEach(element => {
              element.userName = this.lineFourText(element.userName)
            });
            if (this.pageNo == 1) {
              this.list = listArr;
              this.allLoaded = result.pageInfo.isLastPage;
            } else{
                this.list = this.list.concat(listArr);
                this.allLoaded = result.pageInfo.isLastPage;
            }
          }
          
        })
        .catch(error => {
          this.$store.dispatch("setLoadingState", false);
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/function";
$serachInput-height: px2rem(100px);
$gridCell-height: px2rem(70px);
$mes-height: px2rem(120px);
$other-height: px2rem(180px);
$cutLine-height: px2rem(20px);
.font-size-14px {
  font-size: 14px !important;
}
.mint-tab-item-label {
  font-size: 14px !important;
}
.home {
  .fixed-content {
    height: calc(#{$serachInput-height + $other-height + $mes-height + $cutLine-height}) !important;
  }
  .scroll-content {
    top: calc(#{$serachInput-height + $other-height + $mes-height + $cutLine-height + $cutLine-height }) !important;
  }
}
.cut-line {
  height: $cutLine-height;
  background: #f5f5f5;
}
.serachInput {
  height: $serachInput-height;
  // position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 px2rem(20px);
  background: #fff;
  //下拉框
  .dropdownBox {
    display: flex;
    justify-content: center;
    align-items: center;
    .dropdown {
      width: px2rem(115px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .serach {
    height: 70%;
    margin-left: px2rem(25px);
    padding: 0 px2rem(10px);
    border-radius: px2rem(10px);
    display: flex;
    justify-content: center;
    // flex: 1;
    align-self: center;
    input {
      height: 100%;
      // flex: 1;
      width: px2rem(280px);
    }
    .deleteBtn {
      width: px2rem(35px);
      height: px2rem(35px);
      align-self: center;
    }
    .serachBtn {
      width: px2rem(80px);
      height: px2rem(50px);
      line-height: px2rem(50px);
      background: #03a9f4;
      align-self: center;
      border-radius: px2rem(10px);
      text-align: center;
    }
  }
}
.gridWarp {
    display: flex;
    padding: px2rem(20px) 0;
    border-bottom: 1px solid #ececec;
    .gridCell:last-child {
      border-right: none;
    }
    .gridCell {
      font-size: 14px;
      line-height: 18px;
      // flex: 1;
      text-align: center;
      // height: $gridCell-height;
      // line-height: $gridCell-height;
      p {
        color: #333;
        font-size: 14px;
      }
    }
}
.flex-1 {
  flex: 1;
}
.flex-basis-80 {
  flex-basis: px2rem(120px) !important;
  padding: 0 px2rem(10px);
}
.tabBtn .navBar .tabBtnNav {
  padding: px2rem(15px) 0 !important;
  font-size: 14px;
}
.mobileSelect .content .btnBar .cancel, 
.mobileSelect .content .btnBar .ensure {
  font-size: 14px;
}
.mint-loadmore-text {
  font-size: 14px;
}

</style>


// WEBPACK FOOTER //
// Home.vue?66ddf02f